export default __webpack_public_path__ + "static/snowflake_w.75ff869cc1ff190de88c2c9872623c64.png";